import { render, staticRenderFns } from "./apSaleStat.vue?vue&type=template&id=97fb4968&scoped=true&"
import script from "./apSaleStat.vue?vue&type=script&lang=js&"
export * from "./apSaleStat.vue?vue&type=script&lang=js&"
import style0 from "./apSaleStat.vue?vue&type=style&index=0&id=97fb4968&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fb4968",
  null
  
)

component.options.__file = "apSaleStat.vue"
export default component.exports